import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "mt-7 font-medium text-2xl text-center" };
var _hoisted_2 = { class: "mt-5 text-gray text-center max-w-[374px]" };
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrderSuccessfulInstallment',
    setup: function (__props) {
        var router = useRouter();
        var visible = ref(false);
        var t = useI18n().t;
        var show = function () {
            visible.value = false;
        };
        var hide = function () {
            visible.value = false;
        };
        var goMainPage = function () {
            router.push({ name: 'schoolCourses' });
        };
        onMounted(function () {
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('installmentOrdered')) {
                show();
                window.history.replaceState(null, null, window.location.pathname);
            }
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                visible: visible.value,
                name: "order-successful-installment",
                size: "md",
                "append-to-body": "",
                "center-content": "",
                onClose: hide
            }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_e_icon, {
                        class: "w-15 h-16 text-primary",
                        icon: "time-forward"
                    }),
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('dialog.applicationSent')), 1),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('dialog.accessAfterApproval')), 1),
                    _createVNode(_component_e_button, {
                        class: "mt-10 w-full max-w-[400px]",
                        size: "large",
                        onClick: goMainPage
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode(_toDisplayString(_unref(t)('dialog.goToMain')), 1)
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
